import React from 'react'
import { Stack, Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import Callout from '../../Common/callout/Callout'
import { defaultPalette } from '../../../theme/idsTheme'
import sxs from './_sxs'

export const UserFormCallout = () => (
    <Callout color={defaultPalette.primary.main} icon={<InfoIcon />}>
        <Stack>
            <Typography sx={sxs.calloutTitle}>Renseigner mon identifiant RPPS</Typography>
            <Typography>
                Commencez par vous rechercher, puis sélectionnez-vous dans l'annuaire santé à l’aide de la barre de
                recherche (vous devez disposer d'un identifiant RPPS). Vos informations seront ainsi synchronisées avec
                celui-ci. Enfin, n’oubliez pas d’enregistrer.
            </Typography>
        </Stack>
    </Callout>
)
